import React, { createContext } from 'react';
import { OrgSwitcherHook } from 'apps/sigma2-ui/src/components/ui/OrgSwitcher';
import { useOrgSwitcher } from 'apps/sigma2-ui/src/components/ui/OrgSwitcher';

export const OrgSwitcherContext = createContext<OrgSwitcherHook>({
  selectedOrganization: null,
  selectedDatabase: null,
  organizationsVisible: false,
  databasesVisible: false,
  highlightedOrganization: null,
  myOrganizationsDatabasesAndRevisions: null,
  isLoading: false,
  onOrganizationClick: () => {},
  onDatabaseClick: () => {},
  toggleOrganizationsVisible: () => {},
  hideOrgSwitcher: () => {},
  dismissDatabaseSubmenu: () => {},
});

export const OrgSwitcherWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const hook = useOrgSwitcher();

  return (
    <OrgSwitcherContext.Provider value={hook}>
      {children}
    </OrgSwitcherContext.Provider>
  );
};
